// extracted by mini-css-extract-plugin
export default {"wrapperButtonLanguage":"ButtonLanguage_wrapperButtonLanguage__AF-pn"};